import { ProjectSectionType } from '../../../../interfaces/project';
import { ApplicationInterface } from '../../../../interfaces/application';

export const generalSettingsState = (application: ApplicationInterface): ProjectSectionType => {
  if (application.info.website && application.info.name && application.info.supportEmail)
    return 'complete';
};

export const platformState = (application: ApplicationInterface): ProjectSectionType => {
  const { platforms } = application.info;
  const { validRedirectUris } = application.setup;

  if (platforms && platforms.length > 0 && validRedirectUris && validRedirectUris.length > 0)
    return 'complete';
};

export const privacyAndTermsState = (application: ApplicationInterface): ProjectSectionType => {
  if (application.info.privacyUrl && application.info.termsUrl) return 'complete';
};

export const descriptionAndPreviewState = (
  application: ApplicationInterface,
): ProjectSectionType => {
  if (
    application.info.shortDescription &&
    application.info.description &&
    application.info.dataUsePurpose
  )
    return 'complete';
};

export const ratingState = (application: ApplicationInterface): ProjectSectionType => {
  const rating = application.rating?.rating;
  if (rating && rating !== 'TBD' && rating.length >= 3) return 'complete';
};
